function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M40,9H10c-3.866,0-7,3.134-7,7v18c0,3.866,3.134,7,7,7h30c3.866,0,7-3.134,7-7V16C47,12.134,43.866,9,40,9z M30.165,31.021v2.229H19.396V33c0-3.787,2.589-5.481,4.873-6.975c1.931-1.264,3.599-2.354,3.599-4.441c0-0.026-0.077-2.604-2.831-2.604c-2.798,0-2.831,3.576-2.831,3.729v0.25h-2.371l-0.011-0.238c-0.052-1.099,0.062-3.153,1.402-4.559c0.894-0.937,2.175-1.411,3.811-1.411c5.067,0,5.213,4.339,5.213,4.834c0,3.207-2.562,4.824-4.821,6.25c-1.547,0.977-3.014,1.903-3.343,3.186H30.165z"
});

function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.5a3a8a02.svg";
export { ForwardRef as ReactComponent };